import React from 'react';
import { FormattedMessage } from 'react-intl';

import css from './SellerCommissionChart.module.css';

const examples = [
  { sale: '$500', commission: '$100', payout: '$400' },
  { sale: '$1,000', commission: '$200', payout: '$800' },
  { sale: '$5,000', commission: '$1,000', payout: '$4,000' },
];

/**
 * Shows clear examples of the marketplace's fixed seller commission.
 *
 * @component
 * @returns {JSX.Element} Fixed-rate seller commission chart.
 */
const SellerCommissionChart = () => {
  return (
    <section className={css.root} aria-labelledby="seller-commission-chart-title">
      <div className={css.content}>
        <div className={css.intro}>
          <p className={css.eyebrow}>
            <FormattedMessage id="SellerCommissionChart.eyebrow" />
          </p>
          <h2 id="seller-commission-chart-title" className={css.title}>
            <FormattedMessage id="SellerCommissionChart.title" />
          </h2>
          <p className={css.description}>
            <FormattedMessage id="SellerCommissionChart.description" />
          </p>
        </div>

        <div className={css.chartLayout}>
          <div className={css.donut} aria-hidden="true">
            <div className={css.donutCentre}>
              <strong className={css.donutRate}>20%</strong>
              <span className={css.donutLabel}>
                <FormattedMessage id="SellerCommissionChart.marketplaceCommission" />
              </span>
            </div>
          </div>

          <div className={css.table} role="table" aria-label="Commission examples">
            <div className={css.tableHeader} role="row">
              <span role="columnheader">
                <FormattedMessage id="SellerCommissionChart.salePrice" />
              </span>
              <span role="columnheader">
                <FormattedMessage id="SellerCommissionChart.marketplaceCommission" />
              </span>
              <span role="columnheader">
                <FormattedMessage id="SellerCommissionChart.sellerReceives" />
              </span>
            </div>
            {examples.map(example => (
              <div key={example.sale} className={css.tableRow} role="row">
                <strong role="cell">{example.sale}</strong>
                <span className={css.commissionValue} role="cell">
                  {example.commission}
                </span>
                <span role="cell">{example.payout}</span>
              </div>
            ))}
          </div>
        </div>

        <p className={css.note}>
          <FormattedMessage id="SellerCommissionChart.note" />
        </p>
      </div>
    </section>
  );
};

export default SellerCommissionChart;
